import { DatePicker } from "rsuite";
import useDateObject from "./useDateObject";

const now = new Date();

const ranges = [
  {
    label: "Now",
    value: now,
  },
];

const TimeInput = ({
  inputSize,
  field,
  onChange,
  value,
  disabled = false,
  setIsOpen,
  isRecord = false,
}) => {
  const { dateValue } = useDateObject(value);

  return (
    <DatePicker
      id={isRecord ? undefined : `record-input-${field.APIName}`}
      onOpen={updateOpen(true)}
      onClose={updateOpen(false)}
      block
      format="hh:mm aa"
      placement="autoVerticalStart"
      placeholder="HH:MM AA"
      showMeridian
      ranges={ranges}
      onSelect={(val) => {
        if (val === now) {
          return onChange(new Date());
        }

        onChange(val);
      }}
      value={dateValue}
      size={inputSize}
      disabled={disabled}
      onClean={() => onChange(null)}
      preventOverflow
      cleanable={!field?.Required}
    />
  );

  // This allows the parent to know when this component is open.
  function updateOpen(open) {
    if (typeof setIsOpen !== "function") return null;

    return () => setIsOpen(open);
  }
};

export default TimeInput;
